import type { ReactNode } from "react";

import { Box, Checkbox, FormControlLabel } from "@mui/material";

import { BodyTextSmall, BodyTextTiny } from "~/components/Typographies";

interface CheckboxFieldProps {
	checked: boolean;
	description?: ReactNode;
	disabled?: boolean;
	label: ReactNode;
	onChange: (checked: boolean) => void;
}

const CheckboxField = ({ checked, description, disabled, label, onChange }: CheckboxFieldProps) => (
	<FormControlLabel
		control={<Checkbox checked={checked} disabled={disabled} onChange={(e) => onChange(e.target.checked)} />}
		label={
			<Box>
				<BodyTextSmall bold>{label}</BodyTextSmall>
				{description && <BodyTextTiny color="text.secondary">{description}</BodyTextTiny>}
			</Box>
		}
		sx={{ alignItems: "center", gap: 1, mx: 0 }}
	/>
);

export default CheckboxField;
